import { render, staticRenderFns } from "./InterestFollowUpCards.vue?vue&type=template&id=12a3e7a3&"
import script from "./InterestFollowUpCards.vue?vue&type=script&lang=js&"
export * from "./InterestFollowUpCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports